import { render, staticRenderFns } from "./FullScreenWrapper.vue?vue&type=template&id=7ba18481&scoped=true"
import script from "./FullScreenWrapper.vue?vue&type=script&lang=js"
export * from "./FullScreenWrapper.vue?vue&type=script&lang=js"
import style0 from "./FullScreenWrapper.vue?vue&type=style&index=0&id=7ba18481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba18481",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VFlex,VLayout,VMain})
